module.exports = __webpack_public_path__ + "img/mint.15726a9c.png";